<div class="overlay">
  <div class="message">
    {{ errorMessage }}
  </div>
  <div class="actions">
    <button
      type="button"
      ca-action-button
      color="primary"
      (click)="retry.emit()"
      class="retry"
    >
      <mat-icon>refresh</mat-icon>
      {{ "retry" | translate }}
    </button>
    <button
      type="button"
      ca-action-button
      color="warn"
      (click)="remove.emit()"
      class="remove"
    >
      <mat-icon>delete</mat-icon>
      {{ "remove" | translate }}
    </button>
  </div>
</div>
